import guards from '../../guards';

export default [
  {
    path: 'trade-transfer',
    name: 'TradeTransfer',
    component: () => import(/* webpackChunkName: "trade-transfer" */ '../../../views/Admin/Complements/TradeTransfer.vue'),
    beforeEnter: guards.checkHaveEfirma,
  },
  {
    path: 'trade-transfer/:uuid',
    name: 'TradeTransferDetail',
    component: () => import(/* webpackChunkName: "trade-transfer" */ '../../../views/Admin/Complements/TradeTransfer.vue'),
    beforeEnter: guards.checkHaveEfirma,
  },
  {
    path: 'new-rep',
    name: 'NewRep',
    component: () => import(/* webpackChunkName: "new-document-related" */ '../../../views/Admin/Invoices/NewRep.vue'),
    beforeEnter: guards.checkHaveEfirma,
  },
  {
    path: 'sku-catalog',
    name: 'SkuCatalog',
    component: () => import(/* webpackChunkName: "sku-catalog" */ '../../../views/Admin/Invoices/SkuCatalog.vue'),
    beforeEnter: guards.checkHaveEfirma,
  },
  {
    path: 'rep/:uuid/detail',
    name: 'RepDetail',
    component: () => import(/* webpackChunkName: "rep-detail" */ '../../../views/Admin/Invoices/RepDetail.vue'),
  },
  {
    path: 'history',
    name: 'History',
    redirect: { name: 'StampedList' },
    component: () => import(/* webpackChunkName: "invoices-history" */ '../../../views/Admin/Invoices/History/index.vue'),
    children: [
      {
        path: 'trade-transfers',
        name: 'TradeTransfers',
        component: () => import(/* webpackChunkName: "invoices-history-stamped" */ '../../../views/Admin/Invoices/History/TradeTransferList.vue'),
      },
    ],
  },
];
